export default {
  id: 10,
  logo: require('@/assets/training/Microsoft_.NET_logo.svg'),
  name: '.NET',
  subtitle: 'Développer une application en .NET',
  description: {
    details: `<b>.NET</b> est un framework <b>multi-plateforme</b> avancé permettant le
      développement de différents types d'application (Console, Bureau, Web).
      Il comporte plusieurs fonctionnalités clés, telles que la prise en charge
      de plusieurs langages des programmation, des modèles de <b>programmation
      asynchrone</b> et simultanée, ainsi qu'une interoperabilité native.`,
    goals: [
      { id: 1, content: 'Connaître les bonnes pratiques de l\'environnement .NET' },
      { id: 2, content: 'Être capable de tester, debugger et optimiser ses applications' },
      { id: 3, content: 'Disposer d\'une parfaite connaissance de la programmation C#' }
    ],
    needs: [
      {
        id: 1,
        title: 'PUBLIC',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/developer.svg'), name: 'Développeur' }
        ]
      },
      {
        id: 2,
        title: 'PÉDAGOGIE',
        items: [
          { id: 1, logo: require('@/assets/training/60percent.png'), name: null }
        ]
      },
      {
        id: 3,
        title: 'PRÉ-REQUIS',
        alignItems: 'flex-start',
        items: [
          { id: 1, name: 'Avoir une première expérience avec un langage de programmation' },
          { id: 2, name: 'Connaissance de base des concepts objets' }
        ]
      },
      {
        id: 4,
        title: 'OUTILS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/tools/postman.svg'), name: 'Postman' },
          { id: 2, logo: require('@/assets/training/tools/visualStudio.png'), name: 'IDE Visual Studio' }
        ]
      }
    ],
    time: '2 JOURS',
    price: '300 € HT',
    trainer: 'PATRICE'
  },
  program: [
    {
      id: 1,
      title: 'INTRODUCTION AU .NET',
      items: [
        { id: 1, content: 'Pourquoi le .NET ?' },
        { id: 2, content: 'Évolutions depuis ses débuts' },
        { id: 3, content: 'Les différents framework (décomposition)' }
      ]
    },
    {
      id: 2,
      title: 'IDE',
      items: [
        { id: 1, content: 'Visual Studio et VS Code' },
        { id: 2, content: 'Écosystème Microsoft' },
        { id: 3, content: 'Extensions' },
        { id: 4, content: 'Le premier "Hello World"' }
      ]
    },
    {
      id: 3,
      title: 'LANGUAGE C#',
      items: [
        { id: 1, content: 'Syntaxe du language' },
        { id: 2, content: 'Les différents types de données' },
        { id: 3, content: 'Collections génériques' },
        { id: 4, content: 'POO (héritage, polymorphisme, etc…)' },
        { id: 5, content: 'Exceptions' },
        { id: 6, content: 'Async / Await' },
        { id: 7, content: 'Exercices pratiques' }
      ]
    }
  ]
}
